import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'SEOPower',
  url: siteUrl,
  description: 'AI-powered SEO analysis tool that analyzes web pages in real-time and delivers actionable optimization recommendations to boost search engine rankings.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/guide`,
    'query-input': 'required name=search_term_string',
  },
};

const softwareSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'SEOPower',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  url: siteUrl,
  description: 'AI-powered SEO tool that delivers real-time page analysis, keyword insights, and prioritized recommendations for higher search engine rankings.',
  offers: [
    {
      '@type': 'Offer',
      name: 'Single Use',
      priceCurrency: 'USD',
      price: '9.99',
      description: 'One-time single page SEO analysis report.',
    },
    {
      '@type': 'Offer',
      name: 'Dual Use',
      priceCurrency: 'USD',
      price: '18.99',
      description: 'Two SEO analysis reports — ideal for baseline and follow-up comparison.',
    },
    {
      '@type': 'Offer',
      name: 'Quad Use',
      priceCurrency: 'USD',
      price: '34.99',
      description: 'Four SEO analysis reports for thorough ongoing optimization.',
    },
    {
      '@type': 'Offer',
      name: 'Multi Use',
      priceCurrency: 'USD',
      price: '89.99',
      description: 'Ten SEO analysis reports for ongoing optimization and competitor analysis.',
    },
  ],
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'SEOPower',
  url: siteUrl,
  logo: {
    '@type': 'ImageObject',
    url: 'https://static.readdy.ai/image/c35406c68f4851f7123e42c3a05fcb72/7284a9e366c89bc3def167baae8f05df.png',
  },
  sameAs: [
    'https://twitter.com/SEOPower_co',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    email: 'support@seopower.co',
  },
};

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <title>SEOPower.co - Smart AI Search Engine Optimization</title>
      <meta name="description" content="Real-time AI SEO analysis tool. SEOPower uncovers keyword opportunities, audits on-page SEO, and delivers actionable insights to grow your search rankings." />
      <meta name="keywords" content="SEO analysis tool, AI SEO software, search ranking tool, keyword optimization, content SEO analyzer, website SEO tool" />
      <link rel="canonical" href={`${siteUrl}/`} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
